/**
 * iQuicker
 * Copyright 2015
 *
 */
(function() {

	function config($provide, $iq_configProvider, $stateProvider,
		$locationProvider, $controllerProvider, $urlRouterProvider,
		$ocLazyLoadProvider, $httpProvider, localStorageServiceProvider,
		$analyticsProvider,ngClipProvider) {
		$locationProvider.html5Mode(true);

		$locationProvider.hashPrefix("!!");
		$iq_configProvider.config({
			version: iquicker_version,
			client_path: "/home/"
		});

		// 网站统计config   add by nieyy 2016/03/30
		$analyticsProvider.settings.pageTracking.basePath = '/home';
		$analyticsProvider.settings.pageTracking.excludedRoutes = ['/---'];

		$httpProvider.interceptors.push('$iq_httpInterceptor');
		$ocLazyLoadProvider.config({
			version: iquicker_version,
			// Set to true if you want to see what and when is dynamically loaded
			debug: false
		});
		localStorageServiceProvider.setPrefix('iquicker');
        localStorageServiceProvider.setStorageType('sessionStorage');
        //复制到剪切板
		ngClipProvider.setPath("../../lib/plugins/ngclip/ZeroClipboard.swf");
		
		$stateProvider
			.state('index', {
				abstract: true,
				url: "",
				views: {
					"ui-index@": {
						templateUrl: "templates/frame/content.html"
					},
					"ui-left-nav@index": {
						templateUrl: "templates/frame/navigation.html"
					},
					"ui-header@index": {
						templateUrl: "templates/frame/header.html"
					}
				},
				resolve: {
					ifLogin: ["$iq_queue", function($iq_queue) {
						return $iq_queue.get("css_main_loaded").promise;
					}]
				}
			})
			.state('xindex', {
				abstract: true,
				url: "",
				views: {
					"ui-index@": {
						templateUrl: "templates/frame/x-content.html"
					},
					"ui-header@xindex": {
						templateUrl: "templates/frame/x-header.html"
					}
				},
				resolve: {
					ifLogin: ["$iq_queue", function($iq_queue) {
						return $iq_queue.get("css_main_loaded").promise;
					}]
				}
			})
			.state('404', {
				url: "/404",
				views: {
					"ui-index@": {
						templateUrl: "templates/404.html"
					}
				},
				resolve: {
					ifLogin: ["$iq_queue", function($iq_queue) {
						return $iq_queue.get("css_main_loaded").promise;
					}]
				}
			})
			.state('403', {
				url: "/403",
				views: {
					"ui-index@": {
						templateUrl: "templates/403.html"
					}
				},
				resolve: {
					ifLogin: ["$iq_queue", function($iq_queue) {
						return $iq_queue.get("css_main_loaded").promise;
					}]
				}
			})
			.state('4041', {
				url: "/4041",
				views: {
					"ui-index@": {
						templateUrl: "templates/4041.html"
					}
				},
				resolve: {
					ifLogin: ["$iq_queue", function($iq_queue) {
						return $iq_queue.get("css_main_loaded").promise;
					}]
				}
			})
			.state('index.main', {
				url: "/",
				views: {
					"@index": {
						templateUrl: "apps/main/main.html"
					}
				},
				resolve: {
					loadPlugin: function($ocLazyLoad, $stateParams, $http) {
						var ocLazyLoad = $ocLazyLoad.load(
							[{
								"name": 'iq_common',
								"files": ['modules/task/public_task.js',
									'modules/note/public_note.js',
									'modules/schedul/public_schedul.js'
								]
							}]
						);
						return ocLazyLoad;
					}
				}
			})

		.state('index.topic', {
			url: "/topic",
			views: {
				"@index": {
					templateUrl: "apps/main/topic.html"
				}
			},
			data: {
				pageTitle: '话题'
			}
		})

		.state('index.label', {
			url: "/label",
			views: {
				"@index": {
					templateUrl: "apps/main/labelshow.html"
				}
			},
			data: {
				pageTitle: '标签'
			}
		});

		$urlRouterProvider
			.when("/main", "/")
			.when("", "/").when("/redirect/{path:.*}", function($match, $stateParams,
				$location, $injector) {
				var _url = $location.url().replace(/\/redirect\/*/, "");
				var _path = $match.path;
				if (!_path) {
					$location.path("/404");
				} else {

					var _app = _path.split("/")[0];
					//遮罩
					var $iq_loading = $injector.get('$iq_loading');
					var $ocLazyLoad = $injector.get('$ocLazyLoad');
					var $iq_user = $injector.get('$iq_user');

					/**
					 * 获取应用配置
					 */
					var getConfig = function(user) {
						return $injector.get("$q").all([$injector.get('$iqaNavigationService')
							.getConfigRes(), $injector.get('$iq_apps').getAppExtConfig()
						]);
					};
					/**
					 * 获取当前应用配置
					 *
					 */
					var getCurrentConfig = function(args) {

						var defer = $q.defer();
						var appConfig = args[0];
						var appExtConfig = args[1];

						var _thisConfig = appConfig[_app];
						var _thisExtConfig = appExtConfig[_app];
						if (_thisConfig) {
							defer.resolve([_thisConfig, _thisExtConfig]);
						} else {
							defer.reject("没有找到指定模块！" + _path);
						}
						return defer.promise;
					};
					/**
					 * 加载应用配置
					 */
					var loadConfig = function(args, abs) {

						var appConfig = args[0];
						var appExtConfig = args[1];
						var _thisConfig = appConfig[_app];
						//获取额外资源duansz
						var _thisExtConfig ="";
						if(appExtConfig!=undefined&&appExtConfig!=null){
							_thisExtConfig = appExtConfig[_app];
						}
//						var _thisExtConfig = appExtConfig[_app];
						//初始化css路径
						var _css = "";
						if (_thisConfig.css) {
							var tmpTheme = $iq_configProvider.config().theme;
							var prefix = "theme/" + tmpTheme +"/";
							_css = prefix + _thisConfig.css;
						}
						//初始化js路径
						var _js = _thisConfig.jsPath + "/app.min.js";
						var _files = _css ? [_css, _js] : [_js];

						//获取插件列表
						var plugins = [];
						if (_thisConfig.plugins) {
							plugins = plugins.concat(getPlugin_files(_thisConfig.plugins.split(
								",")));
						}
						var loadModule = function() {
							//再加载app.min.js和css
							return $ocLazyLoad.load({
								name: _app,
								files: _files
							});
						};
						//加载额外资源duansz
						var loadExModule = function() {
							//再加载app.min.js和css
							if(_thisExtConfig!=undefined&&appExtConfig!=null&&_thisExtConfig.res!=undefined){
								return $ocLazyLoad.load(_thisExtConfig.res);
							}else{
								return "";
							}
						};
						return $ocLazyLoad.load(plugins) //先加载插件
							.then(loadModule) //再加载模块
							.then(loadExModule)//加载额外资源duansz
							.then(function() {
								//模块加载完成
								$location.replace();
								$location.path(_path);
								$iq_loading.hide();
							}).catch(function(e) {
								//模块加载失败
								console.error("模块加载失败，返回上一状态！");
								console.log(_path, e, plugins);
								$injector.get('$state').reload(); //加载失败 重载当前页面
								$iq_loading.hide();
							});
					};

					$iq_loading.show();

					$iq_user.getUserInfo() //获取用户信息
						.then(getConfig,function(x){
							throw(x);
						}) //用户信息获取成功 获取配置信息
						.then(loadConfig,function(x){
							throw(x);
						}) //配置信息获取成功 加载配置信息
						.catch(function(err) {
							if(err && (err.status == 401 || err.status == 403)){

							}else{
								$location.replace();
								$location.path("/404");
								$iq_loading.hide();
							}
						});



				}
			});

		$urlRouterProvider.otherwise(function($injector, $location) {
			var _path = $location.path();
			//			if(_path.substr(-1) == "/"){
			//				return _path.substring(0,_path.length-1)
			//			}
			if (!_path) {
				return _path;
			}
			if(_path.indexOf("/v2/home")==0){
				location.href = _path;
				return _path;
			}
			var _paths = _path.split("/");
			if (!_paths || _paths.length < 1) {
				return null;
			} else {
				if (_paths.length > 1) {
					var $ocLazyLoad = $injector.get('$ocLazyLoad');
					_app = _paths[1]; //第2个是模块名
					if ($ocLazyLoad.isLoaded(_app)) { //如果模块重复加载

						console.log("模块内部地址错误@", _paths);
						$location.path("/404");
						return "/404";
					}
				} else if (_paths.length == 1) {
					console.log("一级目录错误");
					return "/404";
				}
			}

			var ret = "/redirect" + _path;

			return ret;
		});

	}

	angular
		.module('home')
		.config(['$provide', '$iq_configProvider', '$stateProvider',
			'$locationProvider', '$controllerProvider', '$urlRouterProvider',
			'$ocLazyLoadProvider', '$httpProvider', 'localStorageServiceProvider',
			'$analyticsProvider', 'ngClipProvider', config
		])
		.run(["$rootScope", "$iq_queue", "$state", "$ocLazyLoad", "$iq_config",
			"$iq_user", "$iqaNavigationService", "$location", "$iq_getUserinfo",
			function($rootScope, $iq_queue, $state, $ocLazyLoad, $iq_config, $iq_user,
				$iqaNavigationService, $location, $iq_getUserinfo) {
				$rootScope.$state = $state;
				$rootScope.iq_cur_state_name = $state.current.name;

				$iq_user.getUserInfo().then(function(user){

				    if (window._vds) {
				    	_vds.push(['setCS1', 'username', user.name]);
				    	_vds.push(['setCS2', 'orgid', user.org]);
				        _vds.push(['setCS4', 'userdepartmentid', user.department.id]);
				        _vds.push(['setCS5', 'userdepartmentname', user.department.name]);
				        _vds.push(['setCS6', 'usermobile', user.mobile]);

						$iq_user.getOrgInfo().then(function(user){
						    _vds.push(['setCS3', 'orgname', user.orgName]);
						    _vds.trackPV();
						});
				    }
				});
				$iq_getUserinfo.getAllinfo();
				$iq_user.getTheme().then(function(theme) {
					var tmpTheme = $iq_config.config().theme;
					// var prefix = tmpTheme && tmpTheme != "blue" ?
					// 	"theme/" + tmpTheme + "/" : "";
					var prefix=	"theme/" + tmpTheme + "/";
					$ocLazyLoad.load({
						files: [prefix + 'css/main.css']
					}).then(function() {
						$iq_queue.get("css_main_loaded").resolve();
						//            	$rootScope.$broadcast(ROOTSCOPE_BROADCAST["css_main_loaded"]);
					});
				});


				$rootScope.$on("$locationChangeSuccess", function(event, toState,
					toParams, fromState, fromParams) {
					//百度统计代码
					//_hmt.push(['_trackPageview', location.pathname]);
				});

				$rootScope.$on("$stateChangeSuccess", function(event, toState, toParams,
					fromState, fromParams) {
					$rootScope.iq_cur_state_name = $state.current.name;

					var loopCss = function(list, enable) {

						var i, j = 0;
						for (i = 6; i < document.styleSheets.length; i++) { //跳过前6 前 6个是基础css
							for (j = 0; j < list.length; j++) {
								if (document.styleSheets[i].href && document.styleSheets[i].href
									.indexOf(list[j]) > 0) {
									//判断indexOf>0 不是最准确
									//禁用
									//    		            			console.log("disable CSS:"+document.styleSheets[i].href)
									document.styleSheets[i].disabled = enable;
								}
							}
						}
					};

					var modifyCss = function() {
						var getAppName = function(state) {
							var names = state.name.split(".");
							if (names.length > 1) {
								return names[1];
							} else return null;
						};
						var from = getAppName(fromState);
						var to = getAppName(toState);
						if (from == to) {
							//相同app 不用去掉css
							return;
						}

						$iqaNavigationService.getConfigRes().then(function(appConfig) {
							var disableCSS = [];
							var enableCSS = [];
							//读取appconfig.json中数据
							if (from && appConfig[from]) {
								disableCSS.push(appConfig[from].css);
								loopCss(disableCSS, true);
							}
							if (to && appConfig[to]) {
								enableCSS.push(appConfig[to].css);
								loopCss(enableCSS, false);
							}
						});
					};
					modifyCss();
				});
			}
		]);
})();
